import { connect } from 'react-redux'

import { DinerProfilesSection } from '@components/order/edit/sections'

import coordinators from '@coordinators'
import services from '@services'
import { HandleError } from '@coordinators/composed'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapStateToProps = (_: any) => ({})

const mapDispatchToProps = () => {
  const { RestService } = services
  const { LoadDinerProfiles } = coordinators

  const loadDinerProfiles = LoadDinerProfiles({
    RestService,
    HandleError,
  })

  return {
    loadDinerProfiles,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DinerProfilesSection)
